var _g, _circle, _path, _g2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArm(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 85,
    height: 86,
    viewBox: "0 0 85 86",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_54871_1224)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 42.5,
    cy: 42.7051,
    r: 17.5,
    fill: "#0071FF"
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 50.5,
    cy: 50.5,
    r: 32.5,
    fill: "#0071FF"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_54871_1224)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_54871_1224",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 31,
    y: 31,
    width: 40,
    height: 40
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M71 31H31V71H71V31Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_54871_1224)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M70.5461 66.6304C61.7999 68 53.8833 67.1525 48.6454 65.8301C42.9595 64.3945 39.267 62.5225 39.2305 62.5037C39.1703 62.473 39.1029 62.4588 39.0355 62.4628C36.8547 62.5914 33.2155 62.1431 32.1284 60.3832C31.0288 58.6029 32.7514 56.1306 32.7687 56.1061C32.8073 56.0519 32.8308 55.9885 32.8371 55.9224C32.961 54.6175 33.1614 53.2513 33.4141 51.8669H37.334C37.5433 51.8669 37.7129 51.6972 37.7129 51.4879C37.7129 51.2787 37.5433 51.109 37.334 51.109H33.5575C33.6819 50.4707 33.8163 49.8305 33.9588 49.192H35.8479C36.0572 49.192 36.2269 49.0223 36.2269 48.8131C36.2269 48.6038 36.0572 48.4341 35.8479 48.4341H34.1318C35.8273 41.1594 38.4251 34.3585 38.4604 34.267C38.5354 34.0717 38.438 33.8525 38.2427 33.7773C38.0475 33.7022 37.8281 33.7997 37.7531 33.995C37.7054 34.1187 32.7097 46.276 31.7999 55.6C31.4665 56.1031 30.152 59.1793 31.4 61.2C32.7378 63.3658 36.9671 63.9018 39.0355 63.8C39.6494 64.1014 42.9395 65.5967 48.1999 66.927C51.6311 67.7947 56.4905 68.2482 61.6901 68.2481C64.5508 68.2481 67.587 67.9994 70.6958 67.3733C70.901 67.3319 71.0338 67.1321 70.9924 66.927C70.9511 66.7219 70.7515 66.5892 70.5461 66.6304Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.546 65.1141C66.1174 66.0061 61.4251 66.2108 56.5998 65.7223C56.392 65.7012 56.2057 65.8529 56.1846 66.0611C56.1635 66.2693 56.3152 66.4552 56.5234 66.4763C58.2517 66.6512 59.9634 66.7386 61.6528 66.7386C64.7542 66.7386 67.7806 66.4442 70.6956 65.8571C70.9008 65.8157 71.0335 65.6159 70.9923 65.4107C70.951 65.2057 70.7514 65.0727 70.546 65.1141Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.7191 64.3321C48.5161 64.2811 48.3102 64.4044 48.2593 64.6073C48.2083 64.8104 48.3316 65.0162 48.5345 65.0672C50.2966 65.5096 52.085 65.8697 53.8501 66.1376C53.8694 66.1406 53.8885 66.142 53.9074 66.142C54.0915 66.142 54.2531 66.0076 54.2816 65.8198C54.313 65.613 54.1707 65.4198 53.9638 65.3884C52.2223 65.1241 50.4578 64.7686 48.7191 64.3321Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.3975 52.9365C43.4705 52.9365 43.5443 52.9154 43.6092 52.8715C43.6358 52.8536 46.1147 51.8149 50.7456 50.8C55.0167 49.8641 62.0726 48.6643 70.473 51.8182C70.6688 51.8918 70.8873 51.7926 70.9609 51.5967C71.0345 51.4008 70.6688 50.8735 70.473 50.8C66.6814 49.3765 63.3129 48.4092 59.6 48.2C56.7702 47.5519 53.5339 48.585 50.7456 49.2C48.1345 49.7758 46.1469 50.6985 44.8657 51.3162C47.5121 46.3549 46.0442 34.6408 45.9723 34.0824C45.9455 33.8748 45.7559 33.7287 45.5479 33.755C45.3404 33.7818 45.1938 33.9718 45.2206 34.1793C45.2254 34.2171 44.8949 38.068 44.8657 42.2C44.8276 47.5817 44.7713 51.0189 43.1657 52.2575C43.0037 52.3826 42.9702 52.6135 43.0899 52.7793C43.1638 52.8818 43.2798 52.9365 43.3975 52.9365Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.0989 59.5255C69.3031 59.4798 69.4316 59.2772 69.386 59.073C69.3404 58.8688 69.138 58.7405 68.9335 58.7859C62.0102 60.3346 56.4192 59.937 52.948 59.3309C49.196 58.6756 47.0445 57.6426 47.0113 57.6265C46.8235 57.5346 46.5964 57.6123 46.5044 57.8002C46.4124 57.9882 46.4901 58.2152 46.6781 58.3072C46.768 58.3513 48.5428 59.7224 52.4001 60.4C54.1181 60.7018 56.7584 61 59.4001 61C62.2101 61 65.4589 60.3397 69.0989 59.5255Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.4489 51.8039C63.7538 51.3486 69.9953 53.9508 70.058 53.9771C70.106 53.9973 70.1557 54.0068 70.2048 54.0068C70.3527 54.0068 70.4933 53.9196 70.5542 53.7746C70.6353 53.5817 70.5448 53.3595 70.3518 53.2785C70.0882 53.1676 63.856 50.5688 60.3454 51.0531C60.1381 51.0817 59.9932 51.2729 60.0218 51.4802C60.0504 51.6875 60.2418 51.8329 60.4489 51.8039Z",
    fill: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_54871_1224",
    x: 0,
    y: 0.205078,
    width: 85,
    height: 85,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 12.5,
    result: "effect1_foregroundBlur_54871_1224"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_54871_1224"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white",
    transform: "translate(31 31)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArm);
export default __webpack_public_path__ + "static/media/arm.a1aab275b862a09633956a68617cdc34.svg";
export { ForwardRef as ReactComponent };